import React from 'react'

import type { AnimationType } from '../Asset'
import { video } from './Animation.css'

export const Animation: React.FC<AnimationType> = ({ title, url, loop }) => {
  return (
    <video
      autoPlay={true}
      className={video}
      loop={loop}
      muted={true}
      playsInline={true}
      title={title}
    >
      <source src={url} type={'video/mp4'} />
    </video>
  )
}
